

export default {
    name: 'print-facture-assurance',
    components: {},
    props: {
        is_assurance_bill: {
            type: Boolean,
            default: true
        },
        selected_facture: {
            type: Object,
            default: () => {}
        },
        view_by_societe: {
            type: Array,
            default: []
        },
        view_patients: {
            type: Array,
            default: []
        },
        total_facture: {
            type: Number,
            default: 0
        },
        total_en_lettre: {
            type: String,
            default: ''
        },
        selected_view: {
            type: String,
            default: ''
        },
        type_facture: {
            type: String,
            default: ''
        },
        print_toggler: Number
    },
    data() {
        return {
            can_print: false,
            can_print_soc: false,
            fields: [
                { key: 'date', label: 'Date' },
                { key: 'patient', label: 'Patient' },
                { key: 'num_bon', label: 'Numéro du bon' },
                { key: 'sum_part_assureur', label: 'Total Part Assureur' }
            ],

            field_patients: [
                { key: 'date', label: 'Date' },
                { key: 'prestation', label: 'Prestation' },
                { key: 'pu', label: 'Prix unitaire' },
                { key: 'qte', label: 'Qte' },
                { key: 'part_assureur', label: 'Part Assureur' }
            ],
            perPage: -1,
            print_per_page: -1,
            currentPage: 1
        }
    },

    watch: {
        print_toggler() {
            if ( this.type_facture == 'facture_assurance') {
                this.printCreanceFacture()
            } else {
                this.printFactureSociete()
            }   
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        printCreanceFacture() {
            this.can_print = true

            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 500);
        },

        printFactureSociete() {
            this.can_print_soc = true

            setTimeout(() => {
                window.print()
                this.can_print_soc = false
            }, 500);
        }
    }
}